/* eslint-disable */
import type { AllocationDistribution } from "./AllocationDistribution.pb";
import type { Deduction, Employer, RealizedAllocationAmount } from "./common.pb";

/** A record of one paycheck */
export interface Paycheck {
  /** An identifier for this paycheck */
  paycheck_token?: string;
  /** Settlement information about this paycheck */
  settlement_date?: PaycheckSettlementDate;
  /**
   * The employer issuing the paycheck, if one can be identified.
   *
   * Some of the employers we know very little about may be "empty",
   * in the sense that they have no employer_token or UiSpec.
   * We will use the generic employer avatar for them when displaying
   * the receipt view.
   */
  employer?: Employer;
  /** The distribution used to allocate this paycheck */
  allocation_distribution?: AllocationDistribution;
  /**
   * An ordered list of deductions to display in the receipt view.
   *  These are unsigned (positive-signed) amounts.
   */
  deductions?: Deduction[];
  /**
   * Actual amounts sent to each destination. This may differ from the
   * distribution after accounting for amount restrictions (minimums,
   * atomic transaction sizes, etc).
   */
  realized_allocation_amounts?: RealizedAllocationAmount[];
}

/**
 * An enumeration of current date information that accounts for having
 * an "expected" date in the past because the client's local data
 * store is behind.
 */
export interface PaycheckSettlementDate {
  /** Whether this date is the expected settle date or settled date */
  type?: PaycheckSettlementDateType;
  /**
   * The datetime the paycheck arrived or is expected to arrive.
   * The date format is milliseconds since the unix epoch.
   */
  date?: number;
}

/** Whether this date is the expected settle date or settled date */
export enum PaycheckSettlementDateType {
  EXPECTED = "EXPECTED",
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
}
